export const moneyThousand = (money: string | number | undefined): string => {
	return money ? ((Number(money)).toLocaleString("en-US")) : '0'
}
